// export enum WeatherReportFields {
//   RainFall = 'Rain_Fall',
//   WindSpeedAvg = 'Wind_Speed_Avg',
//   WindSpeedHigh = 'Wind_Speed_High',
//   WindDirectionHigh = 'Wind_Direction_High',
//   WindRun = 'Wind_Run',
//   THWIndex = 'THW_Index',
//   TemperatureOutsideAvg = 'Temprature_Outside_Avg',
//   TemperatureOutsideHigh = 'Temprature_Outside_High',
//   TemperatureOutsideLow = 'Temprature_Outside_Low',
//   TemperatureWindchillAvg = 'Temprature_Windchill_Avg',
//   TemperatureHeatIndexAvg = 'Temprature_HeatIndex_Avg',
//   TemperatureDewPointAvg = 'Temprature_Dewpoint_Avg',
//   TemperatureWetBulbAvg = 'Temprature_Wetbulb_Avg',
//   RainRateHigh = 'Rain_Rate_High',
//   HeatingDegreeDays = 'Heating_DegreeDays',
//   CoolingDegreeDays = 'Cooling_DegreeDays',
//   THSWIndex = 'THSW_Index',
//   SolarRadAvg = 'Solar_Rad_Avg',
//   SolarEnergy = 'Solar_Energy',
//   HighSolarRad = 'High_Solar_Rad',
//   UVIndexAvg = 'UV_Index_Avg',
//   UVDose = 'UV_Dose',
//   HighUVIndex = 'High_UV_Index',
//   ET = 'ET',
//   Humidity = 'Humidity',
// }

export type WeatherReportField = {
  columnName: string
  displayName: string
  metricUnit: string
  imperialUnit: string
  chartAxisName: string
  chartType?: string
}

export const WeatherReportFields: Record<string, WeatherReportField> = {
  RainFall: {
    columnName: 'Rain_Fall',
    displayName: 'Rain Fall',
    metricUnit: 'mm',
    imperialUnit: 'in',
    chartAxisName: 'Rain',
    chartType: 'barChart',
  },
  WindSpeedAvg: {
    columnName: 'Wind_Speed_Avg',
    displayName: 'Wind Speed',
    metricUnit: 'm/s',
    imperialUnit: 'mph',
    chartAxisName: 'Speed',
  },
  WindSpeedHigh: {
    columnName: 'Wind_Speed_High',
    displayName: 'Wind Speed High',
    metricUnit: 'm/s',
    imperialUnit: 'mph',
    chartAxisName: 'Speed',
  },
  WindDirectionHigh: {
    columnName: 'Wind_Direction_High',
    displayName: 'Wind Direction High',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: '',
  },
  WindRun: {
    columnName: 'Wind_Run',
    displayName: 'Wind Run',
    metricUnit: 'm/s',
    imperialUnit: 'mph',
    chartAxisName: 'Speed',
  },
  THWIndex: {
    columnName: 'THW_Index',
    displayName: 'THW Index',
    metricUnit: 'C',
    imperialUnit: 'F',
    chartAxisName: 'Temperature',
  },
  THSWIndex: {
    columnName: 'THSW_Index',
    displayName: 'THSW Index',
    metricUnit: 'C',
    imperialUnit: 'F',
    chartAxisName: 'Temperature',
  },
  TemperatureOutsideAvg: {
    columnName: 'Temprature_Outside_Avg',
    displayName: 'Temperature',
    metricUnit: 'C',
    imperialUnit: 'F',
    chartAxisName: 'Temperature',
  },
  TemperatureOutsideHigh: {
    columnName: 'Temprature_Outside_High',
    displayName: 'High Temperature',
    metricUnit: 'C',
    imperialUnit: 'F',
    chartAxisName: 'Temperature',
  },
  TemperatureOutsideLow: {
    columnName: 'Temprature_Outside_Low',
    displayName: 'Low Temperature',
    metricUnit: 'C',
    imperialUnit: 'F',
    chartAxisName: 'Temperature',
  },
  TemperatureWindchillAvg: {
    columnName: 'Temprature_Windchill_Avg',
    displayName: 'Temperature Windchill',
    metricUnit: 'C',
    imperialUnit: 'F',
    chartAxisName: 'Temperature',
  },
  TemperatureHeatIndexAvg: {
    columnName: 'Temprature_HeatIndex_Avg',
    displayName: 'Temperature Heat Index',
    metricUnit: 'C',
    imperialUnit: 'F',
    chartAxisName: 'Temperature',
  },
  TemperatureDewPointAvg: {
    columnName: 'Temprature_Dewpoint_Avg',
    displayName: 'Temperature Dew Point',
    metricUnit: 'C',
    imperialUnit: 'F',
    chartAxisName: 'Temperature',
  },
  TemperatureWetBulbAvg: {
    columnName: 'Temprature_Wetbulb_Avg',
    displayName: 'Temperature Wet Bulb',
    metricUnit: 'C',
    imperialUnit: 'F',
    chartAxisName: 'Temperature',
  },
  RainRateHigh: {
    columnName: 'Rain_Rate_High',
    displayName: 'Rain Rate High',
    metricUnit: 'mm/h',
    imperialUnit: 'in/h',
    chartAxisName: 'Rain Rate',
  },
  HeatingDegreeDays: {
    columnName: 'Heating_DegreeDays',
    displayName: 'Heating Degree Days',
    metricUnit: 'C',
    imperialUnit: 'F',
    chartAxisName: 'Temperature',
  },
  CoolingDegreeDays: {
    columnName: 'Cooling_DegreeDays',
    displayName: 'Cooling Degree Days',
    metricUnit: 'C',
    imperialUnit: 'F',
    chartAxisName: 'Temperature',
  },
  SolarRadAvg: {
    columnName: 'Solar_Rad_Avg',
    displayName: 'Solar Radiation',
    metricUnit: 'W/m2',
    imperialUnit: 'W/m2',
    chartAxisName: 'Solar Radiation',
  },
  SolarEnergy: {
    columnName: 'Solar_Energy',
    displayName: 'Solar Energy',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: '',
  },
  HighSolarRad: {
    columnName: 'High_Solar_Rad',
    displayName: 'High Solar Radiation',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: '',
  },
  UVIndexAvg: {
    columnName: 'UV_Index_Avg',
    displayName: 'UV Index',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: '',
  },
  UVDose: {
    columnName: 'UV_Dose',
    displayName: 'UV Dose',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: '',
  },
  HighUVIndex: {
    columnName: 'High_UV_Index',
    displayName: 'High UV Index',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: '',
  },
  ET: {
    columnName: 'ET',
    displayName: 'ET',
    metricUnit: 'mm',
    imperialUnit: 'in',
    chartAxisName: 'ET',
    chartType: 'barChart',
  },
  Humidity: {
    columnName: 'Humidity',
    displayName: 'Humidity',
    metricUnit: '%',
    imperialUnit: '%',
    chartAxisName: 'Humidity',
  },
}

export function getColumnDetails(columnName: string) {
  for (const key in WeatherReportFields) {
    const columnDetail =
      WeatherReportFields[key as keyof typeof WeatherReportFields]
    if (columnDetail.columnName.toLowerCase() === columnName.toLowerCase()) {
      return columnDetail
    }
  }
  return undefined
}

export const AllWeatherReportFields = [
  WeatherReportFields.RainFall.columnName,
  WeatherReportFields.WindSpeedAvg.columnName,
  WeatherReportFields.WindSpeedHigh.columnName,
  WeatherReportFields.WindDirectionHigh.columnName,
  WeatherReportFields.WindRun.columnName,
  WeatherReportFields.THWIndex.columnName,
  WeatherReportFields.TemperatureOutsideAvg.columnName,
  WeatherReportFields.TemperatureOutsideHigh.columnName,
  WeatherReportFields.TemperatureOutsideLow.columnName,
  WeatherReportFields.TemperatureWindchillAvg.columnName,
  WeatherReportFields.TemperatureHeatIndexAvg.columnName,
  WeatherReportFields.TemperatureDewPointAvg.columnName,
  WeatherReportFields.TemperatureWetBulbAvg.columnName,
  WeatherReportFields.RainRateHigh.columnName,
  WeatherReportFields.HeatingDegreeDays.columnName,
  WeatherReportFields.CoolingDegreeDays.columnName,
  WeatherReportFields.THSWIndex.columnName,
  WeatherReportFields.SolarRadAvg.columnName,
  WeatherReportFields.SolarEnergy.columnName,
  WeatherReportFields.HighSolarRad.columnName,
  WeatherReportFields.UVIndexAvg.columnName,
  WeatherReportFields.UVDose.columnName,
  WeatherReportFields.HighUVIndex.columnName,
  WeatherReportFields.Humidity.columnName,
  WeatherReportFields.ET.columnName,
]

export const initialState: WeatherDashboardState = {
  latestWeatherReport: {},
  data24h: {},

  rainData: {},
  windDirectionData: {},
  barometerData: {},

  isLoadingLatestWeatherReport: false,
  isLoading24hTemperature: false,
  isLoadingRain: false,
  isLoadingWindDirection: false,
  isLoadingBarometer: false,
  isLoadingAssetData: false,
}

export interface WeatherDashboardState {
  latestWeatherReport: Record<string, WeatherReportData>
  data24h: Record<string, WeatherReportData[]>

  rainData: Record<string, WeatherRainData[]>
  windDirectionData: Record<string, WeatherWindDirectionData>
  barometerData: Record<string, WeatherBarometerData[]>

  isLoadingLatestWeatherReport: boolean
  isLoading24hTemperature: boolean
  isLoadingRain: boolean
  isLoadingWindDirection: boolean
  isLoadingBarometer: boolean
  isLoadingAssetData: boolean
}

export interface WeatherReportData {
  timeSpan: string
  rainFall: number
  windSpeedAvg: number
  windSpeedHigh: number
  windDirectionHigh: number
  windRun: number
  thWIndex: number
  temperatureOutsideAvg: number
  temperatureOutsideHigh: number
  temperatureOutsideLow: number
  temperatureWindchillAvg: number
  temperatureHeatIndexAvg: number
  temperatureDewPointAvg: number
  temperatureWetBulbAvg: number
  rainRateHigh: number
  heatingDegreeDays: number
  coolingDegreeDays: number
  thsWIndex: number
  solarRadAvg: number
  solarEnergy: number
  highSolarRad: number
  uVIndexAvg: number
  uVDose: number
  highUVIndex: number
  et: number
  humidity: number
}

export interface WeatherRainData {
  customName: string
  fieldName: string
  value: number
  color: string
}

export interface WeatherWindDirectionData {
  direction: string
  high: number
  value: number
}

export interface WeatherBarometerData {
  time: string
  timeSpan: string
  value: number
}
